<template>
    <section id="Contact" class="contact-section">
        <div class="contact-wrap">
            <div class="contact-intro">
                <span class="section-kicker">Let’s connect</span>
                <h2>Contact Codettes</h2>
                <p>Have a question about our programs, trainings, partnerships, or supporting the community? Reach out directly.</p>
            </div>
            <div class="contact-grid">
                <a class="contact-card" href="mailto:codettesorg@gmail.com"><v-icon color="primary">fas fa-envelope</v-icon><span><small>Email us</small><strong>codettesorg@gmail.com</strong></span></a>
                <a class="contact-card" href="mailto:juliesundar123@gmail.com"><v-icon color="primary">fas fa-envelope</v-icon><span><small>Reach Julie</small><strong>juliesundar123@gmail.com</strong></span></a>
                <a class="contact-card" href="https://wa.me/5978822698" target="_blank" rel="noopener noreferrer"><v-icon color="primary">fab fa-whatsapp</v-icon><span><small>Call or WhatsApp</small><strong>+597 882 2698</strong></span></a>
                <a class="contact-card" href="https://www.facebook.com/codettesorg/" target="_blank" rel="noopener noreferrer"><v-icon color="primary">fab fa-facebook</v-icon><span><small>Follow updates</small><strong>Codettes on Facebook</strong></span></a>
            </div>
        </div>
    </section>
</template>

<script>
export default { name: "ContactSection" }
</script>

<style scoped>
.contact-section { background: #fff; padding: 76px 8%; }
.contact-wrap { margin: 0 auto; max-width: 1180px; }
.section-kicker { color: #a8007c; display: block; font-size: .72rem; font-weight: 800; letter-spacing: .18em; text-transform: uppercase; }
.contact-intro h2 { color: #24123f; font-size: clamp(2rem, 4vw, 3.4rem); letter-spacing: -.055em; margin: 12px 0; }
.contact-intro p { color: #696276; line-height: 1.7; max-width: 540px; }
.contact-grid { display: grid; gap: 16px; grid-template-columns: repeat(4, minmax(0, 1fr)); margin-top: 32px; }
.contact-card { align-items: flex-start; background: #fbf9fe; border: 1px solid #eee5f3; border-radius: 16px; display: flex; gap: 12px; min-height: 112px; padding: 20px 16px; transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease; }
.contact-card:hover { border-color: #ce128a; box-shadow: 0 12px 24px rgba(50,20,77,.1); transform: translateY(-3px); }
.contact-card span { min-width: 0; }
.contact-card small, .contact-card strong { display: block; }
.contact-card small { color: #746b7d; font-size: .72rem; margin-bottom: 8px; }
.contact-card strong { color: #24123f; font-size: .86rem; overflow-wrap: anywhere; }
@media (max-width: 900px) { .contact-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 600px) { .contact-section { padding: 56px 20px; } .contact-grid { grid-template-columns: 1fr; } }
</style>
